import React, { useEffect, useForm, useState } from 'react'
import img from './../../asset/set.png'
import { Form, Input, Button, message,DatePicker } from 'antd';
import { Link, Route, useHistory } from "react-router-dom";
import { checkInfo, config } from './../../service_psw'
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default function Step1(props) {
    console.log(props);
    const { next } = props
    const reg = new RegExp(/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)
    const [showhand, setshow] = useState('')
    const [fun,setfun] = useState(true)
    const Code = () => {
        var num = Math.random()
        document.getElementById("img").src = `${imgurl}${content}/_control/validateimage?` + num
    }
    useEffect(() => {
        config().then((res) => {
            console.log(res.data.mustInfo);
            if(res.resultCode === 0){
                setshow(res.data.mustInfo)
                setfun(res.data.fun)
            }
        })
    }, [])
    // useEffect(()=>{
    //     if(!fun){
    //         message.warning('密码找回功能未开启，请联系管理员开启')
    //     }
    // },[fun])
    const onFinish = (values) => {
        console.log('Success:', values);
        values.birthDate = moment(values.birthDate).format('YYYY-MM-DD')
        // if(reg.test(values.idcard)||showhand.indexOf('idcard')===-1){
               checkInfo(values).then(res => {
            console.log(res.resultCode);
            if (res.resultCode === 0) {
                message.success('核实账号成功',[0.5])
                next()
            } else {
                message.warning(res.errorMsg,[0.5])
                Code()
            }
        })
        // next()

        }
    //     else{
    //         message.warning('身份证号码格式不正确',[0.5])
    //     }
     
    // };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const imgurl = window.imgpath
    const content = window.subPath
    const imgurlcode = `${imgurl}${content}/_control/validateimage`

    const [form] = Form.useForm()
    form.setFieldsValue({ loginName: 1 })
    return (
        <>
            {/* <div className='remind'>
                如果无法通过验证码或密保问题找回，则可以通过 <Link to="/appeal">密码申诉</Link> 进行找回</div>
            <div className='remind'>如果已经进行了密码申诉，请点击 <Link to='/appealquery'>申诉查询</Link> </div> */}
            {/* <div className='remind'>
                如果无法通过验证码或密保问题找回，则可以通过 <a>密码申诉</a> 进行找回</div>
            <div className='remind'>如果已经进行了密码申诉，请点击 <a>申诉查询</a> </div> */}
         {fun?<Form
                name="basic"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
            {showhand.indexOf('loginName')!==-1?   <Form.Item
                    name="loginName"
                    rules={[
                        {
                            required: true,
                            message: '请输入学工号',
                        },
                    ]}
                >
                    <Input placeholder='请输入学工号' />
                </Form.Item>:null}
            {showhand.indexOf('name')!==-1?   <Form.Item
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '请输入姓名',
                        },
                    ]}
                >
                    <Input placeholder='请输入姓名' />
                </Form.Item>:null}
                {showhand.indexOf('idcard')!==-1?   <Form.Item
                    name="idcard"
                    rules={[
                        {
                            required: true,
                            message: '请输入身份证号',
                        },
                    ]}
                >
                    <Input placeholder='请输入身份证号' />
                </Form.Item>:null}
                {showhand.indexOf('birthDate')!==-1? <Form.Item
                        // style={{ width: '80%' }}
                        // label="验证码"
                        name="birthDate"
                        rules={[
                            {
                                required: true,
                                message: '请输入出生日期',
                            },
                        ]}
                    >
                            <DatePicker    locale={locale}/>
                    </Form.Item>:null}
                    {showhand.indexOf('validateCode')!==-1?   <Form.Item>
                    <Form.Item
                        style={{ width: '80%' }}
                        // label="验证码"
                        name="validateCode"
                        rules={[
                            {
                                required: true,
                                message: '请输入验证码',
                            },
                        ]}
                    >
                        <Input placeholder='请输入验证码' />
                    </Form.Item>
                    <Form.Item>
                        <img id='img' onClick={() => {
                            Code()
                        }} style={{ marginLeft: '10px', height: '32px', cursor: 'pointer' }} src={imgurlcode}></img>
                    </Form.Item>
                    <Form.Item>

                    </Form.Item>
                </Form.Item>:null}

                <Form.Item
                >
                    <Button type="primary" htmlType="submit" style={{ height: '36px', margin: 0 }}>
                        下一步
                    </Button>
                </Form.Item>
            </Form>:<div>密码找回功能未开启，请联系管理员开启</div>}
        </>
    )
}